var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrSyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.707 5.293-5-5a1 1 0 0 0 -1.414 1.414l1.793 1.793-1.486 1.483a5 5 0 0 0 -6.481.481l-6.069 6.072a6.954 6.954 0 0 0 -2.05 4.949v3.1l-2.707 2.708a1 1 0 1 0 1.414 1.414l2.707-2.707h3.1a6.954 6.954 0 0 0 4.949-2.05l6.072-6.072a4.993 4.993 0 0 0 .482-6.478l1.483-1.486 1.793 1.793a1 1 0 0 0 1.414-1.414zm-6.585 6.171-6.072 6.072a4.967 4.967 0 0 1 -3.535 1.464h-2.515v-2.515a5.11 5.11 0 0 1 .095-.976l1.2 1.2a1 1 0 1 0 1.414-1.414l-1.741-1.741a4.989 4.989 0 0 1 .5-.6l1.032-1.04 1.793 1.793a1 1 0 0 0 1.414-1.414l-1.793-1.793 1.586-1.586 1.793 1.793a1 1 0 0 0 1.414-1.414l-1.793-1.793.622-.622a3.073 3.073 0 0 1 4.242 0l.344.344a3 3 0 0 1 0 4.242z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrSyringe);
export default __webpack_public_path__ + "static/media/fi-rr-syringe.8f8a45cc.svg";
export { ForwardRef as ReactComponent };